<template>
  <v-container>
    <landing-create :content="landingCreateContent"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
    <v-dialog v-model="isView">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <form-display
            :questionList="questionsMetadata.questionRawList"
            :formMetadata="surveyForm"
          >
          </form-display>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import FormDisplay from './display/FormDisplay.vue';

// import FormService from '../../../services/medical_registry/form.service';
import services from '../../../services';

const { medicalRegistry, authService } = services;
const { formService, questionService } = medicalRegistry;

export default {
  name: 'Form',
  components: {
    LandingCreate,
    ListComponent,
    FormDisplay,
  },
  data() {
    const component = this;
    return {
      service: formService,
      landingCreateContent: {
        pageTitle: 'Form',
        commands: [
          {
            link: 'form.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
      },
      surveyForm: null,
      isView: false,
      questionsMetadata: {
        questionRawList: [],
      },
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Name',
            value: 'name',
          },
          {
            text: 'Created by',
            value: 'metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: 'metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        URLName: 'form',
        actionDisplay: {
          delete: {
            hasPermission: () => this.usersPermissions.includes('MEDICAL_FORMS_CAN_DELETE'),
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
      usersPermissions: [],
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await formService.archive({ form: item });
        this.$snackbar.show({
          text: 'Successfully deleted form!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.tableMetaData.onClickView = (surveyForm) => {
      this.surveyForm = surveyForm;
      this.isView = true;
    };
    this.questionsMetadata.questionRawList = await questionService.getList();

    this.usersPermissions = authService.getUserPermission();
  },
};
</script>
